import './App.css'
import { BrowserRouter, Route, Routes } from 'react-router';
import { pages, routes } from './helpers/routes.helper';

function App() {
	return (
		<BrowserRouter>
			<Routes>
				<Route path={routes.home} element={pages.home}/>
				<Route path={routes.privacyPolicies} element={pages.privacyPolicies}/>
				<Route path={routes.products} element={pages.products}/>
				<Route path={routes.services} element={pages.services}/>
				<Route path={routes.company} element={pages.company}/>
				<Route path={routes.contact} element={pages.contact}/>
			</Routes>
		</BrowserRouter>
	)
}

export default App;
